export default "__VITE_ASSET__SJl2_njx__"